import React, { MutableRefObject, useEffect, useState } from 'react';
import axios, { AxiosInstance } from 'axios';
import { useAxiosInstance } from '../contexts/AxiosInstanceProvider';
import { APP_ROUTES } from '../routes/AppRouter';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { Sav, SavResponse } from '../interfaces/Sav';
import File from '../components/File';
import Stepper from '../components/ui/Stepper';
import CurrentStatus from '../components/CurrentStatus';
import Deadline from '../components/Deadline';
import Historic from '../components/Historic';
import { STATUS_CODE, Status, StatusInfo } from '../interfaces/Status';
import { StatusItem } from '../interfaces/Status';


export default function ConsultSav (): React.ReactElement {
  const navigate = useNavigate();
  const axiosInstance: MutableRefObject<AxiosInstance | undefined> = useAxiosInstance();
  const [sav, setSav] = useState<Sav|null>(null);
  const { savNumber } = useParams();

  async function getSav () {
    try {
      if (axiosInstance.current !== undefined) {
        const { data } = await axiosInstance.current.get<SavResponse>(
          `/api/sav_files/${ savNumber }`
        );
        if (data !== undefined) {
          let statusFormatted: Status[] = [];

          data.status.forEach((s: StatusInfo) => {
            const results: StatusItem[] = STATUS_CODE.filter(sc => sc.id === s.statusCode);

            if (results.length > 0) {
              results.forEach((sc: StatusItem) => {
                statusFormatted.push({
                  id: sc.id,
                  label: sc.label,
                  icon: sc.icon,
                  step: sc.step,
                  tag: sc.tag,
                  date: new Date(s.statusDate)
                });
              });
            }
          });

          // Order by date DESC
          statusFormatted = statusFormatted.sort((a: Status, b: Status) => {
            return b.date.getTime() - a.date.getTime();
          });

          const savFormatted = {
            id: data.id,
            fileNumber: data.fileNumber,
            model: data.model,
            imei: data.imei,
            msisdn: data.msisdn,
            status: statusFormatted,
            delay: data.delay
          };
          
          setSav(savFormatted);
        } else {
          navigate(
            APP_ROUTES.searchSav,
            {
              state: {isNotFound: true}
            }
          );
        }
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error(error);
      } else {
        console.error('unexpected error: ', error);
      }
    }
  }

  useEffect(() => {
    getSav();
  }, [savNumber]);

  return (
    <>
      <section className="hero is-overlapped">
        <div className="hero-body">
          <div className="container">
            <div className="columns is-centered">
              <div className="column is-9-widescreen is-11-tablet">
                <div className="rows">
                  <div className="row has-text-centered">
                    <Stepper step={ (sav?.status !== undefined && sav?.status.length > 0 ) ? sav?.status[0].step : 1 }/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      { sav !== null && 
        <section className="section has-background-grey-light">
          <div className="container">
            <div className="columns is-centered">
              <div className="column is-4-widescreen is-12-mobile">
                <File fileNumber={ sav.fileNumber }
                  model={ sav.model }/>
                <CurrentStatus status={ sav?.status[0] }/>
                <Deadline delay={ sav.delay }/>
              </div>
              <div className="column is-6-widescreen is-12-mobile">
                <Historic status={ sav.status }/>
              </div>
            </div>
          </div>
        </section>
      }
      
      <section className="section has-background-white">
        <div className="container is-fluid">
          <nav className="breadcrumb"
            aria-label="breadcrumbs">
            <ul>
              <li><a href="https://www.bouyguestelecom.fr/">Accueil</a></li>
              <li><a href="https://www.assistance.bouyguestelecom.fr/s/">Assistance</a></li>
              <li><a href="https://www.assistance.bouyguestelecom.fr/s/home-sav-mobile">SAV Mobile</a></li>
              <li className="is-active"><NavLink to={ APP_ROUTES.home }>Suivi SAV</NavLink></li>
            </ul>
          </nav>
        </div>
      </section>
    </>
  );
}